interface TruncateProps {
  text: string;
  maxLength: number;
  truncateEnding: string;
}

const Truncate: React.FC<TruncateProps> = ({ text, maxLength, truncateEnding }) => {
  const truncatedString: string = text.length > maxLength ? `${text.substring(0, maxLength)}${truncateEnding}` : text;

  return <span>{truncatedString}</span>;
};

export default Truncate;
